<template>
  <div class="Register">
    <AppBox class="box">
      <div class="bigTitle">企业注册</div>
      <el-form
          ref="form"
          :rules="formRule"
          :model="form"
          size="small"
          v-loading="loading"
          element-loading-text="企业注册中，请稍后..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-form-item prop="tenantName">
          <el-input
              style="width: 300px"
              v-model="form.tenantName"
              placeholder="企业名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="nickname">
          <el-input
              style="width: 300px"
              v-model="form.nickname"
              placeholder="姓名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input
              style="width: 300px"
              v-model="form.phone"
              placeholder="手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="captcha">
          <el-input
              style="width: 160px"
              v-model="form.captcha"
              placeholder="请输入验证码"
          ></el-input>
          <el-button
              style="display: inline-block;
                      width: 130px;
                      margin-left: 10px;"
              @click="getCaptcha(form.phone)"
              :disabled="countingDown"
              size="small"
              :type="countingDown ? '' : 'primary'"
          >{{ countingDown ? `重新获取(${counter})s` : "获取验证码" }}
          </el-button>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
              style="width: 300px"
              placeholder="登录密码"
              v-model="form.password"
              show-password
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
              style="width: 300px"
              class="loginBtn"
              type="primary"
              @click="registerTenantHandle"
          >注册
          </el-button>
        </el-form-item>
      </el-form>
    </AppBox>
  </div>
</template>

<script>
import {loginMixin} from "@/mixins/loginMixins";
import {mapActions} from "vuex";

export default {
  name: "Register",
  components: {},
  mixins: [loginMixin],
  data() {
    return {
      loading: false,
      form: {},
      formRule: {
        tenantName: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        nickname: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: ["blur", "change"],
          },
        ],
        captcha: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
      }
    };
  },
  methods: {
    ...mapActions("user", ["sendSms", "registerTenant"]),
    async registerTenantHandle() {
      this.$refs.form.validate(async (validate) => {
        if (validate) {
          try {
            this.loading = true;
            await this.registerTenant(this.form);
            this.$message.success("注册成功")
            await this.$router.push({name: "Login"})
          } finally {
            this.loading = false;
          }
        }
      })
    },
    //发送验证码
    async getCaptcha(phone) {
      if (this.countingDown) return;
      this.$refs.form.validateField("phone", async (errorMsg) => {
        if (!errorMsg) {
          try {
            await this.sendSms({
              phone: phone,
            });
            this.startCounter();
            this.$message.success("验证码发送成功，请查看手机短信");
          } catch (e) {
            console.log(e);
          }
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.Register {
  height: 100vh;
  background: map-get($colors, primary);
  display: flex;
  align-items: center;
  justify-content: center;

  .box {
    width: 400px;
    background: #ffffff;
    padding: 20px;
    position: relative;
    text-align: center;

    .bigTitle {
      color: map-get($colors, primary);
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }
}
</style>
